import { render } from "./LeftArrow.vue?vue&type=template&id=79eb63e6"
import script from "./LeftArrow.vue?vue&type=script&lang=js"
export * from "./LeftArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__